import { useState, useEffect } from 'react'
import { Accordion, Offcanvas, Spinner } from 'react-bootstrap'
import axios from 'axios'

const legend = {
  info: {
    label: 'Informational only / No Concern',
    icon: 'fa-solid fa-circle-exclamation text-gray-400',
    color: 'text-primary',
  },
  potential: {
    label: 'Potential for Concern',
    icon: 'fa-solid fa-triangle-exclamation',
    color: 'text-gray-400',
  },
  low: {
    label: 'Low  Concern',
    icon: 'fa-solid fa-triangle-exclamation text-warning',
    color: 'text-warning',
  },
  medium: {
    label: 'Medium  Concern',
    icon: 'fa-solid fa-bell text-warning',
    color: 'text-warning',
  },
  high: { label: 'High concern', icon: 'fa-solid fa-bell text-danger', color: 'text-danger' },
}
interface Alert {
  eventTitle: string
  description: string
  concernLevel: string
  date: string
}
const Legend = ({ legend }) => (
  <div>
    <h6>Concern Levels:</h6>
    {Object.keys(legend).map((concern) => (
      <p key={concern}>
        <label className={legend[concern].color}>
          <i className={legend[concern].icon}></i>
        </label>{' '}
        {legend[concern].label}
      </p>
    ))}
  </div>
)

const BluedotNewsfeedDropdown = () => {
  const [selectedConcern, setSelectedConcern] = useState('info')

  const [apiData, setApiData] = useState<Alert[]>([])
  const API_URL = process.env.REACT_APP_API_URL
  const [show, setShow] = useState(false)
  const [showContaint, setShowContaint] = useState(false)

  const handleClose = () => {
    setShow(false)
    setShowContaint(false)
  }
  const handleShow = () => {
    setShow(true)
    setTimeout(() => {
      setShowContaint(true)
    }, 1000)

  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}/bluedot`)
        setApiData(response.data.data)

      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data
      }
    }

    fetchData()
  }, [API_URL])

  return (
    <div>
      {/* <Button variant='primary' onClick={handleShow} className='me-2'>
        <i className='fa-solid fa-circle-exclamation'></i> {` Bluedot Newsfeed`}
      </Button> */}

      {/* Move Offcanvas outside of the main div */}
      <Offcanvas scroll={true} placement={'end'} show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Legend</Offcanvas.Title>
        </Offcanvas.Header>
        {show && showContaint ? (
          <Offcanvas.Body className='p-0'>
            <div className='px-6'>
              <Legend legend={legend} />
            </div>

            <Accordion className='p-0 m-0'>
              {apiData.map((alert, index) => (
                <Accordion.Item key={index} eventKey={index.toString()}>
                  <Accordion.Header>
                    {(() => {
                      switch (alert.concernLevel) {
                        case 'Watchlist Alert':
                          return <i className='fa-solid fa-circle-exclamation text-gray-400 '></i>
                        case 'Not a concern':
                          return <i className='fa-solid fa-triangle-exclamation'></i>
                        case 'Low concern level':
                          return <i className='fa-solid fa-triangle-exclamation text-warning '></i>
                        case 'Medium concern level':
                          return <i className='fa-solid fa-bell text-warning '></i>
                        default:
                          return <i className='fa-solid fa-bell text-danger '></i>
                      }
                    })()}
                    <div className='mx-2'>
                      {' '}
                      {alert.date} : {alert.eventTitle}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>{alert.description}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Offcanvas.Body>
        ) : (
          <>
            {show ? (
              <Offcanvas.Body>
                {' '}
                <Spinner animation='border' role='status'>
                  <span className='visually-hidden'>Loading...</span>
                </Spinner>
              </Offcanvas.Body>
            ) : (
              <></>
            )}
          </>
        )}
      </Offcanvas>
    </div>
  )
}

export default BluedotNewsfeedDropdown
